import { NoResult as NoResult_filmzi } from './NoResult.filmzi';
import { NoResult as NoResult_kojaro } from './NoResult.kojaro';
import { NoResult as NoResult_pedal } from './NoResult.pedal';
import { NoResult as NoResult_zoomg } from './NoResult.zoomg';
import { NoResult as NoResult_zoomit } from './NoResult.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_TENANT) {
    case 'filmzi':
      return NoResult_filmzi;

    case 'kojaro':
      return NoResult_kojaro;

    case 'pedal':
      return NoResult_pedal;

    case 'zoomg':
      return NoResult_zoomg;

    default:
      return NoResult_zoomit;
  }
};

export const NoResult = IconRenderer();
